// A short confirmation at the foot of the screen ("Copied"), spoken by screen readers, gone after
// a moment. `copyText` puts text on the clipboard and says whether it could.
import { type ReactNode, useCallback, useEffect, useRef, useState } from 'react'

const SHOWN_MS = 1800

export function useToast(): { toast: ReactNode; show: (text: string) => void } {
  const [text, setText] = useState<string | null>(null)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  const show = useCallback((next: string) => {
    setText(next)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => setText(null), SHOWN_MS)
  }, [])
  useEffect(() => () => clearTimeout(timer.current), [])
  return {
    toast: (
      <div className="toast" role="status" hidden={text === null}>
        {text}
      </div>
    ),
    show,
  }
}

/** Puts text on the clipboard; false when the browser refused. */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
